import Link from 'next/link'
import Image from 'next/image'
import { Box, Stack } from '@mui/joy'
import AspectRatio from '@mui/joy/AspectRatio'
import { Text } from '../../Text'

export default function BlogBlock({ link, id, title, author, src }) {
    return (
        <Link href={link} passHref prefetch={false}>
            <Box
                id={id}
                as="a"
                target="_blank"
                overflow="hidden"
                backgroundColor="#fff"
                p={0}
            >
                <Stack spacing={3}>
                    <AspectRatio ratio="253 / 150">
                        <Image
                            quality={80}
                            src={src}
                            fill
                            style={{
                                objectFit: 'cover',
                            }}
                        />
                    </AspectRatio>
                    <Text
                        sx={{
                            fontWeight: 700,
                            color: '#0d417d',
                            textDecoration: 'none',
                            fontSize: '1.25rem',
                        }}
                    >
                        {title}
                    </Text>
                    <Text
                        size=".9rem"
                        sx={{
                            fontWeight: 300,
                            color: '#000',
                        }}
                    >
                        {author}
                    </Text>
                </Stack>
            </Box>
        </Link>
    )
}
